import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  dateRange: Yup.array().required().min(1, 'Please select your rental period'),
  pickupTimeBlock: Yup.string().required('Please select pickup time'),
  dropoffTimeBlock: Yup.string().required('Please select dropoff time'),
});
